<template>
  <div class="chartOne">
    <!-- <h6 class="black">{{ chartTitle + chartUnit }}</h6> -->
    <div :id="codMain" class="codMain"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    codMain: String,
    ChartData: Object,
  },
  data() {
    return {
      one: this.ChartData,
      timer: null,
      codChart: null,
      chartData: {},
      seriesData: [],
      openIndex: null,
      chartTitle: "",
      chartUnit: "",
      initOption: {
        animation: true,
        animationDuration: 1500,
        grid: {
          top: "10%",
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          confine: false,
          trigger: "axis",
          axisPointer: {
            type: "line",
            z: 0,
            lineStyle: {
              color: "#2D3443",
            },
          },
          textStyle: {
            align: "left",
          },
          extraCssText: "z-index: 99999",
        },
        series: [
          {
            name: "",
            data: "",
            symbol: "none",
            smooth: true,
            lineStyle: { width: 1.6 },
            type: "line",
            label: {
              show: false,
              position: "right",
            },
            itemStyle: {
              lineStyle: {
                color: '"#1890ff"',
                width: 1.2,
              },
            },
            zlevel: 999,
          },
        ],
      },
    };
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    if (this.codChart) {
      this.codChart.dispose();
      this.codChart = null;
    }
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.initChart();
    this.timer = window.setInterval(() => {
      this.initChart();
    }, 300000);
    window.addEventListener("resize", this.handleResize);
  },
  computed: {
    ...mapState(["theme"]),
  },
  watch: {
    "$store.state.open"(newVal, oldVal) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.codChart) {
            this.codChart.resize();
          }
        }, 10);
      });
    },
    ChartData(newval) {
      if (newval) {
        this.initChart();
      }
    },
    theme() {
      if (this.codChart) {
        this.codChart.dispose();
        this.codChart = null;
      }
      this.initChart();
    },
  },
  methods: {
    handleResize() {
      if (this.codChart) {
        this.codChart.resize();
      }
    },
    initChart() {
      // 添加空值检查
      if (!this.ChartData || !this.ChartData.xAxis || !this.ChartData.legend) {
        return;
      }

      const domElement = document.getElementById(this.codMain);
      if (!domElement) {
        return;
      }

      console.log(this.ChartData.xAxis[this.ChartData.xAxis.length - 1]);
      this.chartUnit = this.ChartData.legend[0].unit;
      if (this.chartUnit == '-') {
        this.chartUnit = '';
      }
      
      this.initOption.xAxis.data = this.ChartData.xAxis;
      
      // 重置 series 数组，避免旧数据残留
      this.initOption.series = [];
      
      this.ChartData.legend.map((item, index) => {
        this.initOption.title = {
          left: "center",
          text: this.chartTitle,
          show: false,
        };
        this.initOption.yAxis = [
          {
            type: "value",
            splitLine: {
              show: false
            }
          },
        ];
        
        if (index === 0) {
          this.initOption.series[index] = {
            name: item.name,
            data: item.yAxis,
            symbol: "none",
            smooth: true,
            lineStyle: { width: 1.6 },
            type: "line",
            label: {
              show: false,
              position: "right",
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                  [{
                    offset: 0,
                    color: "rgb(36, 102, 168)",
                  }, {
                    offset: 1, 
                    color: 'rgb(57, 188, 176)'
                  }]),
              },
            },
            itemStyle: {
              normal: {
                color: '#40E0D0',
                lineStyle: {
                  color: 'rgb(36, 102, 168)',
                }
              }
            },
          };
        } else {
          this.initOption.series[index] = {
            name: item.name,
            data: item.yAxis,
            symbol: "none",
            smooth: true,
            lineStyle: { width: 1.6 },
            type: "line",
            label: {
              show: false,
              position: "right",
            },
            itemStyle: {
              lineStyle: {
                color: 'rgba(35, 86, 138, 1)',
                width: 1.2,
              },
            },
          };
        }
      });

      // 移除重复的图表初始化代码，复用实例
      if (!this.codChart) {
        this.codChart = this.$echarts.init(domElement);
      }
      
      this.codChart.clear();
      this.codChart.setOption(this.initOption, true);
    },
  },
};
</script>

<style lang="scss" scoped>
.chartOne {
  width: 100%;
  height: 100%;
  margin: 0 auto;

  ::-webkit-scrollbar {
    border-radius: 6px;
    width: 5px !important;
    background-color: #ccc;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 6px;
    background-color: #989898;
    height: 30px;
  }

  .codMain {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    z-index: 99;
  }

  h6 {
    padding-left: 36px;
    text-align: left;
    font-size: 12px;
    color: rgb(76, 76, 76);
    font-weight: 600;
  }
}
</style>
